/**
 * THE STATIC REGISTRY — the only file that imports `src/tenants/<key>/`, exactly like the
 * API's `app/modules.py`. `_reference` is dev-only and compiles out of a production export.
 */
import { DEV_TOOLS } from "../api/devFlag";
import type { TenantModule } from "../domain/tenantModule";
import { kcc } from "./kcc/module";
import { reference } from "./_reference/module";

export const modules: TenantModule[] = [kcc, ...(DEV_TOOLS ? [reference] : [])];

const seen = new Set<string>();
for (const module of modules) {
  if (seen.has(module.key)) {
    throw new Error(`Duplicate tenant module key in the registry: ${module.key}`);
  }
  seen.add(module.key);
}
